module.exports = __webpack_public_path__ + "img/carrusel_02.75c26565.jpg";